import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaign.steps)?_c(VCard,{staticClass:"design-wrapper page",attrs:{"height":"100%"}},[_c('campaigns-save-bar'),_c(VCard,{staticClass:"edit-wrapper-outer no-radius elevation-0"},[_c('page')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }